/*!
 * CerviCalme — JS consolidé pour la fiche oreiller ergonomique.
 * Charge en defer via theme.liquid. Aucune variable Liquid n'est interpolée
 * ici : les valeurs spécifiques produit sont lues via data-attributes ou via
 * le bloc <script type="application/json" id="oreiller-data-*"> (data bridge).
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function readDataBridge() {
    var el = document.querySelector('[id^="oreiller-data-"]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  var oreillerData = readDataBridge();

  function lazyInit(selector, init, rootMargin) {
    var el = document.querySelector(selector);
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      init(el);
      return;
    }
    new IntersectionObserver(function (entries, observer) {
      if (!entries[0].isIntersecting) return;
      init(el);
      observer.disconnect();
    }, { rootMargin: rootMargin || '300px' }).observe(el);
  }

  /* ──────────────────────────────────────────────────────────────────────
   * Module : Onglets avis par sujet (sections/cervicalme-testimonials-tabs)
   * ────────────────────────────────────────────────────────────────────── */
  function initTestimonialsTabs(root) {
    if (!root || root.dataset.cervicalmeReady === 'true') return;
    root.dataset.cervicalmeReady = 'true';

    var tabs = root.querySelectorAll('[data-cervicalme-tab]');
    var panels = root.querySelectorAll('[data-cervicalme-panel]');

    function activate(cat) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-cervicalme-tab') === cat;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.style.background = on ? '#1E4FB8' : '#E8F0FE';
        t.style.color = on ? '#FFFFFF' : '#1E4FB8';
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-cervicalme-panel') === cat;
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(t.getAttribute('data-cervicalme-tab'));
      });
    });
  }

  /* ──────────────────────────────────────────────────────────────────────
   * Module : Hook couple — bouton qui scroll vers le bundle selector
   * (sections/cervicalme-couple-hook)
   * ────────────────────────────────────────────────────────────────────── */
  function initCoupleHook() {
    var button = document.querySelector('[data-cervicalme-couple-bundle]');
    if (!button || button.dataset.cervicalmeReady === 'true') return;
    button.dataset.cervicalmeReady = 'true';

    button.addEventListener('click', function () {
      var selector = document.querySelector('[data-cervicalme-bundle-selector]');
      if (selector && typeof selector.scrollIntoView === 'function') {
        selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      document.dispatchEvent(new CustomEvent('cervicalme:bundle-select', {
        bubbles: true,
        detail: { qty: 2 }
      }));
    });
  }

  /* ──────────────────────────────────────────────────────────────────────
   * Module : FAQ étendue — set data attribute pour styling CSS
   * (sections/cervicalme-faq-extended)
   * ────────────────────────────────────────────────────────────────────── */
  function initFaqExtended() {
    var faqRoots = document.querySelectorAll('details');
    var found = null;
    for (var i = 0; i < faqRoots.length; i++) {
      var section = faqRoots[i].closest('.section');
      if (section && section.querySelector('details')) {
        var h = section.querySelector('h2');
        if (h && h.textContent && h.textContent.indexOf('Questions') !== -1) {
          found = section;
          break;
        }
      }
    }
    if (found && !found.hasAttribute('data-cervicalme-faq')) {
      found.setAttribute('data-cervicalme-faq', '');
    }
  }

  /* ──────────────────────────────────────────────────────────────────────
   * Module : Bundle selector (snippets/cervicalme-bundle-selector)
   * ────────────────────────────────────────────────────────────────────── */
  function initBundleSelector(root) {
    if (!root || root.dataset.cervicalmeReady === 'true') return;
    root.dataset.cervicalmeReady = 'true';

    var cards = root.querySelectorAll('[data-cervicalme-bundle-card]');
    var propertyInput = root.querySelector('[data-cervicalme-bundle-property]');
    var hint = root.querySelector('[data-cervicalme-bundle-hint]');

    function formatHint(qty) {
      if (qty === '1') return 'Un seul oreiller, le choix simple pour découvrir le confort CerviCalme.';
      if (qty === '3') return 'Le meilleur prix par oreiller pour équiper la maison.';
      return 'Un oreiller chacun, même confort, même soutien.';
    }

    function applyCardState(card, active) {
      card.style.borderColor = active ? '#2F6FED' : '#E5E7EB';
      card.style.backgroundColor = active ? '#F8FBFF' : '#FFFFFF';
      card.style.boxShadow = active ? '0 10px 24px rgba(47, 111, 237, 0.14)' : 'none';
      card.setAttribute('aria-pressed', active ? 'true' : 'false');

      var badge = card.querySelector('span[style*="position: absolute"]');
      if (badge) {
        badge.style.backgroundColor = active ? '#2F6FED' : '#E8F0FE';
        badge.style.color = active ? '#FFFFFF' : '#1E4FB8';
      }
    }

    function syncQuantity(qty) {
      var formRoot = root.closest('product-form-component');
      var quantityComponent = formRoot ? formRoot.querySelector('quantity-selector-component') : null;
      var quantityInput = quantityComponent ? quantityComponent.querySelector('input[name="quantity"]') : null;

      if (!quantityInput && formRoot) {
        quantityInput = formRoot.querySelector('input[name="quantity"]');
      }
      if (!quantityInput) return;

      quantityInput.value = qty;
      if (quantityComponent && typeof quantityComponent.setValue === 'function') {
        quantityComponent.setValue(qty);
      }
      if (quantityComponent && typeof quantityComponent.updateButtonStates === 'function') {
        quantityComponent.updateButtonStates();
      }
      if (quantityComponent && typeof quantityComponent.onQuantityChange === 'function') {
        quantityComponent.onQuantityChange();
      } else {
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function selectBundle(qty, emitEvent) {
      var selected = null;

      for (var i = 0; i < cards.length; i++) {
        var isActive = cards[i].getAttribute('data-qty') === qty;
        applyCardState(cards[i], isActive);
        if (isActive) selected = cards[i];
      }

      if (!selected) return;

      if (propertyInput) propertyInput.value = qty;
      syncQuantity(qty);
      if (hint) hint.textContent = formatHint(qty);

      if (emitEvent) {
        root.dispatchEvent(new CustomEvent('cervicalme:bundle-changed', {
          bubbles: true,
          detail: {
            qty: Number(qty),
            price: Number(selected.getAttribute('data-price-cents')),
            unit_price: Number(selected.getAttribute('data-unit-cents')),
            price_decimal: selected.getAttribute('data-price'),
            unit_price_decimal: selected.getAttribute('data-unit'),
            price_formatted: selected.getAttribute('data-price-formatted'),
            unit_price_formatted: selected.getAttribute('data-unit-formatted'),
            label: selected.getAttribute('data-label')
          }
        }));
      }
    }

    for (var i = 0; i < cards.length; i++) {
      cards[i].addEventListener('click', function () {
        selectBundle(this.getAttribute('data-qty'), true);
      });
    }

    document.addEventListener('cervicalme:bundle-select', function (event) {
      if (!event.detail || !event.detail.qty) return;
      selectBundle(String(event.detail.qty), true);
    });

    document.addEventListener('cervicalme:bundle-changed', function (event) {
      if (event.target === root || !event.detail || !event.detail.qty) return;
      selectBundle(String(event.detail.qty), true);
    });

    selectBundle(root.getAttribute('data-default-qty') || '1', true);
  }

  /* ──────────────────────────────────────────────────────────────────────
   * Module : Countdown expédition (snippets/cervicalme-shipping-countdown)
   * ────────────────────────────────────────────────────────────────────── */
  function initShippingCountdown(root) {
    if (!root || root.dataset.cervicalmeReady === 'true') return;
    root.dataset.cervicalmeReady = 'true';

    var dayEl = root.querySelector('[data-cervicalme-ship-day]');
    var countEl = root.querySelector('[data-cervicalme-countdown]');
    if (!dayEl || !countEl) return;

    function atCutoff(date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 14, 0, 0, 0);
    }

    function nextShippingTarget(now) {
      var cutoff = atCutoff(now);
      if (now < cutoff) return { label: "aujourd'hui", target: cutoff };
      var tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(14, 0, 0, 0);
      return { label: 'demain', target: tomorrow };
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function render() {
      var now = new Date();
      var shipping = nextShippingTarget(now);
      var diff = Math.max(0, shipping.target.getTime() - now.getTime());
      var totalSeconds = Math.floor(diff / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      dayEl.textContent = shipping.label;
      countEl.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }

    render();
    window.setInterval(render, 1000);
  }

  /* ──────────────────────────────────────────────────────────────────────
   * Module : Sticky CTA (snippets/cervicalme-sticky-cta)
   * Correction obligatoire : rAF throttle dans le callback IntersectionObserver
   * ────────────────────────────────────────────────────────────────────── */
  function initStickyCta(root) {
    if (!root || root.dataset.cervicalmeReady === 'true') return;
    root.dataset.cervicalmeReady = 'true';

    var labelEl = root.querySelector('[data-cervicalme-sticky-label]');
    var priceEl = root.querySelector('[data-cervicalme-sticky-price]');
    var addButton = root.querySelector('[data-cervicalme-sticky-add]');
    var hasReachedMainButton = false;
    var rafPending = false;
    var lastEntry = null;

    function setVisible(visible) {
      root.style.transform = visible ? 'translateY(0)' : 'translateY(110%)';
      root.style.pointerEvents = visible ? 'auto' : 'none';
      root.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (addButton) addButton.tabIndex = visible ? 0 : -1;
    }

    function updateFromDetail(detail) {
      if (!detail) return;

      var qty = Number(detail.qty || 1);
      var label = detail.label || (qty === 1 ? '1 oreiller' : 'Lot de ' + qty);
      var unit = detail.unit_price_formatted || '';
      var price = detail.price_formatted || '';

      if (labelEl) {
        labelEl.textContent = unit ? label + ' - ' + unit + '/oreiller' : label;
      }
      if (priceEl && price) {
        priceEl.textContent = price;
      }
    }

    function updateFromActiveBundle() {
      var active = document.querySelector('[data-cervicalme-bundle-card][aria-pressed="true"]');
      if (!active) return;

      updateFromDetail({
        qty: active.getAttribute('data-qty'),
        label: active.getAttribute('data-label'),
        price_formatted: active.getAttribute('data-price-formatted'),
        unit_price_formatted: active.getAttribute('data-unit-formatted')
      });
    }

    function findMainAddButton() {
      var formRoot = document.querySelector('product-form-component[data-product-url]');
      if (!formRoot) return null;
      return formRoot.querySelector('button[name="add"]');
    }

    function evaluateVisibility(mainButton, entry) {
      if (entry && entry.isIntersecting) {
        hasReachedMainButton = true;
        setVisible(false);
        return;
      }
      var rect = mainButton.getBoundingClientRect();
      setVisible(hasReachedMainButton && rect.bottom <= 0);
    }

    function observeMainButton() {
      var mainButton = findMainAddButton();
      if (!mainButton) return;
      var initialRect = mainButton.getBoundingClientRect();
      hasReachedMainButton = initialRect.top < window.innerHeight;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          lastEntry = entries[0];
          if (rafPending) return;
          rafPending = true;
          requestAnimationFrame(function () {
            rafPending = false;
            evaluateVisibility(mainButton, lastEntry);
          });
        }, { threshold: 0 });
        observer.observe(mainButton);
      } else {
        window.addEventListener('scroll', function () {
          if (rafPending) return;
          rafPending = true;
          requestAnimationFrame(function () {
            rafPending = false;
            var rect = mainButton.getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > 0) {
              hasReachedMainButton = true;
              setVisible(false);
              return;
            }
            setVisible(hasReachedMainButton && rect.bottom <= 0);
          });
        }, { passive: true });
      }
    }

    document.addEventListener('cervicalme:bundle-changed', function (event) {
      updateFromDetail(event.detail);
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        var mainButton = findMainAddButton();
        if (mainButton && !mainButton.disabled) {
          mainButton.click();
        }
      });
    }

    setVisible(false);
    updateFromActiveBundle();
    observeMainButton();
  }

  /* ──────────────────────────────────────────────────────────────────────
   * Boot
   * ────────────────────────────────────────────────────────────────────── */
  ready(function () {
    try {
      var testimonialsRoot = document.querySelector('[data-cervicalme-testimonials]');
      if (testimonialsRoot) {
        lazyInit('[data-cervicalme-testimonials]', initTestimonialsTabs, '300px');
      }

      initCoupleHook();
      initFaqExtended();

      var bundleRoot = document.querySelector('[data-cervicalme-bundle-selector]');
      if (bundleRoot) initBundleSelector(bundleRoot);

      var countdownRoot = document.querySelector('[data-cervicalme-shipping-countdown]');
      if (countdownRoot) initShippingCountdown(countdownRoot);

      var stickyRoot = document.querySelector('[data-cervicalme-sticky-cta]');
      if (stickyRoot) initStickyCta(stickyRoot);
    } catch (error) {
      // silencieux : ne jamais bloquer le rendu
    }
  });
})();
